import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Mismo programa digital que /mi-programa/$slug, pero bajo /portal/…: el Portal instalado como app
// tiene `scope: "/portal"` (manifest.json), así que un enlace a cualquier ruta fuera de ese prefijo
// se abre en Safari en vez de quedarse dentro de la app. Desde el Panel del Portal se enlaza acá.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/portal/programa/$slug",
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: lazyRouteComponent(() => import("./programa-digital-page"), "ProgramaDigitalPage"),
});
